import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../Store";
import { Graph_QL, useSystem } from "../../../../Services";
import { useDeviceInfo } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useDeviceInfo";
import { colors, frames } from "../../../../Styles";
import { PageHeader, IoTable, LfSettings } from "../../../../Components";
import { Pages } from "../../../../Navigation/root";

const SYSTEM_ID = 1;

export default function FreedaLocationFeeder() {
  const { t } = useTranslation();

  const { systemId: urlSystemId } = useParams(); // TODO routing changes in order to get a correct system info
  const systemId = urlSystemId ? +urlSystemId : SYSTEM_ID;

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemCall, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemCall({ ids: [systemId] });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);

  // Get System Name for Header
  const system = useMemo(() => {
    return systemsState[domain]?.data.find(
      (system) => system.system_id === systemId
    );
  }, [domain, systemId, systemsState]);
  
  const { data: deviceInfoState, call: getDeviceInfo, maintainEntries: maintainDeviceInfo } = useDeviceInfo(connection);

  const deviceInfo = useMemo(() => {
    if (deviceInfoState[domain]) {
      return deviceInfoState[domain].data.filter((device) => device?.system_assignment === systemId );
    }
    return [];
  }, [deviceInfoState, domain, systemId]);

  useEffect(() => {
    getDeviceInfo({ fetchAmount: 500 }, connection);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);
  // #endregion

  const seperator = <div style={{ width: "95%", height: "1px", backgroundColor: colors.greyDarkPrimary }} />

  return (
    <frames.Page_inner>
        <PageHeader topHeader={system?.name} subHeader={t(`menuHeaders.${Pages.freeda_lf_settings}`, { defaultValue: "settings" })} />

      <frames._page_inner_content_scroll>
        
        <div style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column" }} >
          <LfSettings/>
          {seperator}
          <IoTable deviceInfo={deviceInfo} maxTableHeight="400px" showSystemRow={false} maintainDeviceInfo={maintainDeviceInfo} />
        </div>
        
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}
